import { VApp } from 'vuetify/lib/components/VApp';
import { VMain } from 'vuetify/lib/components/VMain';
import Scroll from 'vuetify/lib/directives/scroll';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VApp,{directives:[{def: Scroll,name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}]},[_c('search-top-bar',{attrs:{"app-bar-top-props":_vm.appBarTopProps}}),_c(VMain,[_c('router-view')],1),_c('common-bottom-bar',{attrs:{"app-bar-bottom-props":_vm.appBarBottomProps,"current-scroll":_vm.currentScroll}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }